import React from "react";
import {IonModal} from "@ionic/react";
import MapLegend from "./MapLegend";
import CloseButton from "../../utils/buttons/CloseButton";
import {EOperationType} from "../../../models/utils/EOperationType";

/**
 * Component available on mobile with a legend to filter the information on the map
 * @author Alizée Grand
 * @version 1.2
 * @creation 26/04/2021
 * @last_update 13/01/2022
 **/
class MobileLegendPopup extends React.Component<{
    /**
     * Whether the modal is open or not.
     */
    showPopup: boolean,
    /**
     * Function to close the pop-up.
     */
    onPopupDismiss: () => void,
    /**
     * Function called when the user clicks on a filter.
     * @param {EOperationType} filter Filter called.
     */
    onFilterClick: (filter?: EOperationType) => void
}> {

    render() {

        return (
            <IonModal
                isOpen={this.props.showPopup}
                onDidDismiss={this.props.onPopupDismiss}
                id="legendPopover"
            >

                <CloseButton
                    onClickAction={this.props.onPopupDismiss}
                />

                <MapLegend onFilterClick={this.props.onFilterClick}/>

            </IonModal>
        );
    };

}

export default MobileLegendPopup;
